import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import Editor from "../components/Editor";
import {
  addOrUpdateCardsThunk,
  deleteCardsThunk,
} from "../modules/cardReducer";

const EditorContainer = () => {
  const dispatch = useDispatch();
  const cards = useSelector((state) => state.cards);
  const { userId } = useSelector((state) => state.user);

  const handleAddOrUpdateCards = useCallback(
    (card) => {
      dispatch(addOrUpdateCardsThunk(userId, card));
    },
    [dispatch, userId]
  );

  const handleDeleteCards = useCallback(
    (card) => {
      dispatch(deleteCardsThunk(userId, card));
    },
    [dispatch, userId]
  );

  return (
    <Editor
      cards={cards || {}}
      onAddOrUpdate={handleAddOrUpdateCards}
      onDelete={handleDeleteCards}
    />
  );
};

export default EditorContainer;
